export class JwtService {
  private static readonly tokenKey = 'token';
  private static _token: string | null;

  static getJwt(): string | null {
    if (!JwtService._token) {
      JwtService._token = localStorage.getItem(JwtService.tokenKey)
    }
    return JwtService._token;
  }

  static saveJwt(token: string) {
    JwtService._token = token;
    localStorage.setItem(JwtService.tokenKey, token)
  }

  static clear() {
    JwtService._token = null;
    localStorage.removeItem(JwtService.tokenKey);
  }
}
